<template>
	<div class="row">
		<div class="col-sm-6">
			<sBox title="Grade de regiões">
				<div slot="tools">
					<aBtn
						action="private-save-regions"
						text="Categoria"
						icon="plus"
						size="sm"
						type="success"
						@click="(data) => $refs.mdl.open()"
					/>
				</div>
				<div slot="body">
					<br />
					<div class="row">
						<div class="pull-right col-sm-12">
							<div class="input-group">
								<span class="input-group-addon">
									<i class="fa fa-search"></i>
								</span>
								<input
									type="text"
									@input="filter($event.target.value)"
									placeholder="Pesquisar"
									class="form-control"
								/>
							</div>
						</div>
					</div>
					<br />
					<sTable
						ref="tab"
						actionRead="private-read-regions"
						actionDelete="private-delete-regions"
						:labels="labels"
						:actions="['delete', 'edit']"
						:functions="functions"
						@edit="(data) => $refs.mdl.open(data)"
					/>
				</div>
			</sBox>
		</div>

		<div class="col-sm-6">
			<TiposDeClientes />
		</div>

		<modal ref="mdl" @updata="$refs.tab.updateTable()" />
	</div>
</template>
<script>
	// import WBS from 'js/http'
	import sTable from 'table';
	import sBox from 'box';
	import aBtn from 'btn';
	import modal from './modal.vue';
	import TiposDeClientes from './tipos.de.cliente.vue';

	import pad from 'js/pad';

	export default {
		name: 'AppCadastroCategorias',
		components: { sTable, sBox, aBtn, modal, TiposDeClientes },
		data() {
			return {
				labels: [
					{ data: 'cod', label: 'Cod' },
					{ data: 'regiao', label: 'Região' },
					{ data: 'localidade', label: 'Localidade' },
				],
				functions: [
					{
						cod: 'cod',
						fx: (val) => {
							return pad(val, 5);
						},
					},
					{ cod: 'regiao', fx: this.modificator },
				],
			};
		},
		methods: {
			modificator(val) {
				let resp = `<span class='label label-success'>`;
				resp += `<i class='fa fa-map-marker'></i> ${val}`;
				resp += `</span>`;
				return resp;
			},
			filter(data) {
				if (data != '') {
					this.$refs.tab.setFilter(`
							cod like '%${data}%' or 
							regiao like '%${data}%' or
							localidade like '%${data}%' 
					`);
				} else this.$refs.tab.setFilter('');
				this.$refs.tab.updateTable();
			},
		},
		mounted() {
			this.$emit('setHeader', ['Regiões e Tipos de Clientes', '']);
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/cadastros/regions/index.vue